export default {
    requestPreviousQuestion:    'requestPreviousQuestion',
    requestNextQuestion:        'requestNextQuestion',
    requestPreviousBlock:       'requestPreviousBlock',
    requestNextBlock:           'requestNextBlock',
    requestGoBack:              'requestGoBack',
    requestSetQuestionNumber:   'requestSetQuestionNumber',
    requestEndTest:             'requestEndTest',
    requestMarkQuestion:        'requestMarkQuestion',
    requestUnmarkQuestion:      'requestUnmarkQuestion',
    requestGoToBookmarks:       'requestGoToBookmarks',
    requestSubCategoryTimedOut: 'requestSubCategoryTimedOut',
    requestGoToPreviousBookmark: 'requestGoToPreviousBookmark',
    requestGoToNextBookmark:    'requestGoToNextBookmark',

    sessionEnded:       'sessionEnded',
    previousQuestion:   'previousQuestion',
    nextQuestion:       'nextQuestion',
    previousBlock:      'previousBlock',
    nextBlock:          'nextBlock',
    goBack:             'goBack',
    setQuestionNumber:  'setQuestionNumber',
    markQuestion:       'markQuestion',
    unmarkQuestion:     'unmarkQuestion',

    pauseTestTimer:     'pauseTestTimer',
    resumeTestTimer:    'resumeTestTimer',

    cancelEndModal:      'cancelEndModal',

    ignoreQuestion: 'ignoreQuestion',
    startTest: 'startTest',
    endTest: 'endTest',
    endSelfRating: 'endSelfRating',
    quitTest: 'quitTest',
    subCategoryTimedOut: 'subCategoryTimedOut',
    testTimedOut: 'testTimedOut',
    testModeChanged: 'testModeChanged',
    blockChanged: 'blockChanged',
    subCategoryChanged: 'subCategoryChanged',
    mainCategoryChanged: 'mainCategoryChanged',
    loadMoreExerciseQuestions: 'loadMoreExerciseQuestions',
    selectAnswer: 'selectAnswer',

    postInsertMemorizationInterstitialVisibilityChanged: 'postInsertMemorizationInterstitialVisibilityChanged',
    requestContinuePostInsertMemorizationInterstitial: 'requestContinuePostInsertMemorizationInterstitial',
}
